import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import MedicoForm from 'components/forms/MedicoForm';
import { useMedico, useSalvarMedico, SalvarMedicoDTO } from 'hooks/useMedicos';
import { Navigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { SubmitHandler } from 'react-hook-form';

const EditarMedico = () => {
    const { id } = useParams<{ id: string }>();
    const { data: medico, isLoading } = useMedico(Number(id));
    const { mutate, isSuccess, isPending } = useSalvarMedico();

    const handleSubmit: SubmitHandler<SalvarMedicoDTO> = data => {
        mutate({ ...data, id: Number(id) });
    };

    if (isLoading) {
        return <Spinner animation="border" />;
    }

    if (isSuccess) {
        return <Navigate to="/cadastros/medicos" />;
    }

    return (
        <div>
            <PageBreadcrumb
                items={[
                    { label: 'Retaguarda', url: '/retaguarda' },
                    { label: 'Médicos', url: '/cadastros/medicos' },
                    { label: 'Editar Médico', active: true }
                ]}
            />
            <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
                <div>
                    <h2 className="mb-2">Editar Médico</h2>
                    <h5 className="text-body-tertiary fw-semibold">
                        Altere as informações do médico
                    </h5>
                </div>
                <div className="d-flex flex-wrap gap-2">
                    <Button variant="phoenix-secondary" type="button">
                        Descartar
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        form="medico-form"
                        loading={isPending}
                        disabled={isPending}
                        loadingPosition="start"
                    >
                        Salvar
                    </Button>
                </div>
            </div>
            <MedicoForm
                id="medico-form"
                onSubmit={handleSubmit}
                initialData={medico}
                isSubmitting={isPending}
            />
        </div>
    );
};

export default EditarMedico; 